// extracted by mini-css-extract-plugin
export default {"action":"d17293d20d40ac08","rowLabel":"ea662868d9e78ea6"};